<template >
    <div>
        <div class="store-header">
            <div class="header-btns">
                <button class="cart-header-btn" @click="dropIt" >
                    <i  class="fa fa-shopping-cart">
                        <div v-if="cart.length - 1 !== 0" class="cart-badge">
                            {{cart.length - 1}}
                        </div>
                    </i>
                </button>
                <button  class="cart-header-btn" @click="$router.push('/@'+store_slug)">
                    <i class="fa fa-home"></i>
                </button>
            </div>

            <div class="cart-list">
                <transition name="fade">
                    <div class="main-transition" >

                    <div class="main-list"  v-click-outside="dropIt"  v-if="isDropped">


                    <ul class="list"  >
                        <div v-bind:key="c.amount" v-for="c in cart">
                            <div v-if="cart.length - 1">


                                <li v-if="c.id">
                                    <div><img class="cart-image" :src="c.image"></div>
                                    <div><h4 class="list-title">{{c.title}}</h4><h4 class="cart-des">{{c.amount}} ریال</h4></div>
                                    <div><button class="list-btn" @click="destroy(c)"><i class="fa fa-trash"></i></button></div>

                                </li>
                            </div>

                            <div v-else class="empty-cart" >
                                <i class="cart-arrow fa fa-cart-arrow-down" >
                                    "سبد خالیست!"
                                </i>

                            </div>

                        </div>


                    </ul>

                    </div>
                        <div v-if="isDropped" >
                            <div class="cart-slide-btn">
                                <button style="border-radius: 20px; margin: -10px 5px ;"  class="cart-btn" @click="$router.push('/cart/@'+ store_slug)">{{ $t('btn.allCart') }}
                                </button>
                            </div>
                        </div>
                    </div >


                </transition>
            </div>

        </div>

    </div>

</template>

<script>
    import { mapGetters } from 'vuex'

    export default {
        directives: {

            'click-outside': {
                bind: function (el, binding, vnode) {
                    window.event = function (event) {
                        vnode.context[binding.expression](event);
                        if (event.target.className === "cart-header-btn" || event.target.className === "list-btn"|| event.target.className === "fa fa-shopping-cart" || event.target.className === "fa fa-trash"){
                            vnode.context[binding.expression](event);
                        }
                        if (el.contains(event.target)){
                            vnode.context[binding.expression](event);
                        }
                    };
                    document.body.addEventListener('click', window.event)
                },
                unbind: function (el) {
                    document.body.removeEventListener('click', window.event)
                },
            }
        },

        computed: {

            ...mapGetters('cart',['cart']),
            ...mapGetters('store', [
                'store', 'status'
            ]),
        },

        data() {
            return {
                store_slug: this.$route.params.store,
                'isDropped': false
            }
        },
       created(){

            if(localStorage.getItem('allCart') != null ){
                if (this.cart.length !== JSON.parse( (localStorage.getItem('allCart'))).length){
                    for (let i = 0 ; i < JSON.parse(localStorage.getItem('allCart')).length ; i++){
                        if (JSON.parse(localStorage.getItem('allCart'))[i] && JSON.stringify(localStorage.getItem('allCart'))[i]){
                            this.$store.dispatch('cart/add',JSON.parse(localStorage.getItem('allCart'))[i])
                        }
                    }
                }
            }
        },


        methods: {
            destroy(data){
                this.$store.dispatch('cart/remove',data)
                localStorage.setItem('allCart',JSON.stringify(this.cart))
            },
            addCart(product){
                this.$store.dispatch('cart/add',product)
            },
            dropIt() {
                this.isDropped = !this.isDropped
            }
        }
    }

</script>

<style scoped>

    html {
        display: grid;
        height: 100%;
    }

    body {
        margin: auto;
        background: linear-gradient(#5e2973, #692424);
    }


    button:focus {
        outline: solid thin #ff1c99;
    }
    .empty-cart{
        background-color: #f9f9fc;
        border-radius: 5px;
    }
    .cart-arrow{
        margin: 76px 73px;
        float: left;
        font-size: 15px;
        padding: 40px;

    }
    .main-list{
        position: inherit;
        padding: 0px;
        z-index: 1;
        width: 350px;
        margin: -10px 50px;
        -webkit-transform-origin: top;
        transform-origin: top;
        transition: -webkit-transform .4s ease-in-out;
        -webkit-transition: -webkit-transform .4s ease-in-out;
        transition: transform .4s ease-in-out;
        transition: transform .4s ease-in-out, -webkit-transform .4s ease-in-out;
        border: 1px solid rgba(29, 201, 183, 0.1);
        border-radius: 5px;
        background-color: white;
        box-shadow:0px 0px 12px grey;
        height: 350px;
    }
    .list {
        list-style-type: none;
        overflow: auto;
        height: 270px;
        margin: 10px -41px;
        width: 390px;

    }
    .list li {
        display: grid;
        grid-template-columns: 83px 170px 50px;
        grid-gap: 20px;
        height: 100px;
        background: #ffffff;
        border-bottom: solid thin #eeeeee;
    }

    .cart-image{
        width: 100%;
        margin: 8px 10px;
        border-radius: 10%;
    }
    .cart-des{
        margin: -12px 10px;
        font-size: 12px;
    }
    .cart-btn{
        width: 100%;
        height: 50px;
        color: #1ebeae;
        border: 0;
        background-color: #e7f2f4;
    }
    .fade-enter-active, .fade-leave-active {
        transition: opacity .5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;

    }
    .list-title{
        margin: 15px 0px;
        padding: 10px 10px;
    }
    .list-btn{
        margin: 40px 0px;
        width: 30px;
        height: 30px;
        border-radius: 15px;
        background-color: red;
        color: white;
        border: 0;
        padding: 7px;
    }
    .cart-list{
        display: grid;
        grid-template-rows: 1fr 1fr;
    }
    .header-btns{
        margin: 0px 40px;
    }
    .main-transition{
        z-index: 100;
    }
    .cart-slide-btn{
        border-radius: 20px;
        margin: -55px 57px;
        width: 25%;
    }
    .cart-badge-icon{
        display: flex;
        direction: ltr;
        padding: 5px 0px;
    }
    .cart-badge{
        margin: -25px -18px;
        background-color: red;
        padding: 1px;
        font-size: 11px;
        width: 15px;
        height: 15px;
        text-align: center;
        color: white;
        border-radius: 7px;
        position: absolute;
    }
    @media (max-width: 800px) {
       .main-list{
           margin: -10px 20px;
       }
        .cart-btn{
            width: 270px;
        }
    }
</style>